// For investigation purposes of MA-84
import type { DynamicPageLink, EditorReadyOptions, EditorSDK } from '@wix/platform-editor-sdk';

import { log } from '../../utils/monitoring';
import * as constants from '../constants';
import { APP_TOKEN } from '../constants';
import * as menusWrapper from '../wrappers/menus';

export async function verifyMyAccountPage(options: EditorReadyOptions, editorSDK: EditorSDK) {
  if (options.firstInstall) {
    return;
  }

  try {
    const menuItems = await menusWrapper.getMenuItems({ editorSDK, menuId: constants.MENU_IDS.SUB_MENU_ID });
    const myAccountMenuItem = menuItems.find((i) => (i?.link as DynamicPageLink)?.innerRoute === 'my-account');
    const allPages = await editorSDK.pages.data.getAll(APP_TOKEN);
    const myAccountPage = allPages.find((p) => p.tpaPageId === 'member_info');

    if (!myAccountPage && !!myAccountMenuItem) {
      log('editorLoad: MA-84 My account menu item is there, but the page is missing');
    }
  } catch (e) {
    log('Verifying My Account page failed', { tags: { reason: (e as Error).toString() } });
  }
}
